import {
  DetalleTransporteDeFecha,
  EntradaTransporteDeFecha,
} from "../../../services/transporteServicios";
import { ListGroupItem } from "react-bootstrap";
import VisibilityIcon from "@mui/icons-material/Visibility";
import IconContainer from "../../organisms/IconContainer";

import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";

import EditIcon from "@mui/icons-material/Edit";
import { ModificacionesDetalle } from "./Modificaciones";

function EntradaItem({
  entrada,
  onDetalleClick,
  onChequearEntrada,
  modificacionesEntrada,
  onSubirOrden,
  esPrimero,
  anterior,
  siguiente,
  onBajarOrden,
  esUltimo,
}: {
  entrada: EntradaTransporteDeFecha;
  onDetalleClick: (detalle: DetalleTransporteDeFecha) => void;
  onChequearEntrada: (
    entrada: EntradaTransporteDeFecha,
    transportado: boolean
  ) => void;
  onSubirOrden: (
    entrada: EntradaTransporteDeFecha,
    anterior: EntradaTransporteDeFecha
  ) => void;
  onBajarOrden: (
    entrada: EntradaTransporteDeFecha,
    siguiente: EntradaTransporteDeFecha
  ) => void;
  modificacionesEntrada: ModificacionesDetalle | undefined;
  esPrimero: boolean;
  esUltimo: boolean;
  anterior: EntradaTransporteDeFecha | undefined;
  siguiente: EntradaTransporteDeFecha | undefined;
}) {
  const onDetalleViewEditClick = () => {
    onDetalleClick(entrada);
  };

  const transportado =
    modificacionesEntrada && modificacionesEntrada.transportado !== undefined
      ? modificacionesEntrada.transportado
      : entrada.transportado;

  return (
    <ListGroupItem
      as="li"
      className={`d-flex mt-2 p-1 border rounded ${transportado ? "border-success" : ""
        }`}
    >
      <div className="ps-2 row" style={{ paddingRight: 0, marginRight: 0, width: '100%' }}>
        <div className="row" style={{ paddingRight: 0, marginRight: 0, width: '100%' }}>
          <div className="col-7" style={{ paddingRight: 0, marginRight: 0 }}>
            <strong>{entrada.mascota.nombre}</strong>
          </div>
          <div className="col-5" style={{ paddingRight: 0, marginRight: 0 }}>
            <div
              className="d-flex justify-content-end ps-2"
              style={{ paddingRight: 0 }}
            >
              {!esPrimero && (
                <div className="d-flex justify-content-end ps-2">
                  <IconContainer
                    onClick={() => {
                      onSubirOrden(entrada, anterior!);
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <ArrowUpwardIcon />
                  </IconContainer>
                </div>
              )}

              {!esUltimo && (
                <div className="d-flex ps-2">
                  <IconContainer
                    onClick={() => {
                      onBajarOrden(entrada, siguiente!);
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <ArrowDownwardIcon />
                  </IconContainer>
                </div>
              )}
              <div className="d-flex ps-2">
                <IconContainer
                  onClick={onDetalleViewEditClick}
                  style={{ cursor: "pointer" }}
                >
                  {transportado ? <VisibilityIcon /> : <EditIcon />}
                </IconContainer>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <small>{entrada.hora}</small>
        </div>
        <div className="row">
          <small>
            {entrada.direccion} - {entrada.sector.nombre}
          </small>
        </div>
      </div>
    </ListGroupItem>
  );
}

export default EntradaItem;
